// TODO: move to cds-icons once brand icons are supported
import * as React from 'react';

import { CalendarIcon } from '@coursera/cds-icons';

export const GoogleCalendarIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    aria-hidden="true"
    focusable="false"
  >
    <g clipPath="url(#google-cal-clip)">
      <path
        d="M19.6 10.2275C19.6 9.51831 19.5367 8.83581 19.4183 8.18164H10V12.05H15.3817C15.2704 12.6618 15.0363 13.2447 14.6934 13.7635C14.3505 14.2823 13.906 14.7262 13.3867 15.0683V17.5766H16.6183C18.5092 15.8366 19.6 13.2733 19.6 10.2275Z"
        fill="#3587FC"
      />
      <path
        d="M10.0001 19.9999C12.7001 19.9999 14.9635 19.1041 16.6185 17.5774L13.3868 15.0682C12.491 15.6682 11.3451 16.0224 10.0001 16.0224C7.39598 16.0224 5.19181 14.2641 4.40431 11.8999H1.06348V14.4916C1.89575 16.1481 3.17231 17.5406 4.75049 18.5133C6.32866 19.4861 8.14626 20.0008 10.0001 19.9999Z"
        fill="#22A880"
      />
      <path
        d="M4.40417 11.9C4.19858 11.2875 4.09306 10.646 4.09167 9.99997C4.09167 9.34163 4.205 8.69997 4.405 8.09997V5.5083H1.06333C0.363321 6.90206 -0.000831332 8.44029 1.42507e-06 9.99997C1.42507e-06 11.6133 0.386668 13.1416 1.06333 14.4916L4.40417 11.9Z"
        fill="#FFC936"
      />
      <path
        d="M10.0001 3.9775C11.4685 3.9775 12.7868 4.48167 13.8226 5.4725L16.691 2.60417C14.9593 0.991667 12.696 0 10.0001 0C6.09181 0 2.70848 2.24167 1.06348 5.50833L4.40514 8.1C5.19014 5.73667 7.39514 3.9775 10.0001 3.9775Z"
        fill="#ED2644"
      />
    </g>
    <defs>
      <clipPath id="google-cal-clip">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const AppleCalendarIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="20"
    viewBox="0 0 17 20"
    fill="none"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M16.5349 15.5861C16.2317 16.2848 15.8728 16.928 15.4569 17.5194C14.8901 18.3255 14.426 18.8835 14.0683 19.1934C13.5138 19.702 12.9198 19.9625 12.2836 19.9773C11.8269 19.9773 11.2762 19.8477 10.6351 19.5847C9.99187 19.323 9.40078 19.1934 8.8603 19.1934C8.29346 19.1934 7.68551 19.323 7.03527 19.5847C6.38402 19.8477 5.85938 19.9847 5.45825 19.9983C4.84823 20.0242 4.24018 19.7563 3.63324 19.1934C3.24584 18.8563 2.76132 18.2786 2.18085 17.4601C1.55807 16.586 1.04606 15.5725 0.644936 14.417C0.21535 13.1689 0 11.9603 0 10.7902C0 9.44985 0.290354 8.29383 0.871923 7.3251C1.32899 6.54696 1.93704 5.93316 2.69807 5.48256C3.45908 5.03195 4.28138 4.80233 5.16692 4.78764C5.65146 4.78764 6.28686 4.93714 7.07648 5.23096C7.86387 5.52577 8.36944 5.67526 8.59111 5.67526C8.75682 5.67526 9.31848 5.50046 10.2706 5.15195C11.171 4.82875 11.9309 4.69492 12.5534 4.74763C14.2403 4.88345 15.5077 5.54676 16.3505 6.74177C14.8418 7.6536 14.0955 8.93073 14.1104 10.5691C14.124 11.8452 14.5881 12.9071 15.5003 13.7503C15.9136 14.1417 16.3753 14.4441 16.8889 14.6589C16.7775 14.9812 16.6599 15.2898 16.5349 15.5861ZM12.6661 0.400102C12.6661 1.40034 12.2997 2.33424 11.5695 3.19866C10.6883 4.22629 9.62244 4.82009 8.4666 4.72639C8.45112 4.60065 8.44335 4.47408 8.44333 4.3474C8.44333 3.38717 8.86239 2.35956 9.6066 1.51933C9.97814 1.0939 10.4507 0.74018 11.0237 0.458003C11.5955 0.180037 12.1363 0.0263141 12.645 0C12.6599 0.13371 12.6661 0.267436 12.6661 0.400102Z"
      fill="var(--cds-color-neutral-primary)"
    />
  </svg>
);

export const OtherCalendarIcon = () => <CalendarIcon size="small" aria-hidden="true" />;
